/* global gdAlertify */
import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../config/axiosConfig"; // Asegúrate de importar correctamente tu instancia de Axios.
import { Grid, _ } from 'gridjs-react';
import { gridOptions } from "../utils/gridOptions";
import { formatDate } from "../utils/utils";
import { calculateAge } from "../utils/utils";
import GdTable from "./components/GdTable";
import { useNavigate } from 'react-router-dom';

const clasificacionMap = {
    0: '',
    1: 'Básico 0',
    2: 'Básico 0-1',
    3: 'Básico 1',
    4: 'Básico 1-2',
    5: 'Básico 2',
    6: 'Básico 2-3',
    7: 'Básico 3',
    8: 'D',
};


const DetalleAuxiliar = ({ isOpen, onClose, details, observaciones }) => {
    const columns2 = [
        { name: "idAcuerdo", title: "ID", width: 100 },
        { name: 'paciente', title: 'Nombre paciente', width: 200 },
        { name: 'fechaInicio', title: 'Fecha Inicio', render: (row) => formatDate(row.fechaInicio), width: 200 },
        { name: 'fechaFin', title: 'Fecha Fin', render: (row) => formatDate(row.fechaFin), width: 100 },
        { name: "estado", title: "Estado", render: (row) => row.estado === 1 ? 'Activo' : 'Cerrado', width: 100 },
    ]
    const columns3 = [
        { name: "observacionID", title: "ID", width: 100 },
        { name: 'fecha', title: 'Fecha', render: (row) => formatDate(row.fecha), width: 100 },
        { name: 'observacion', title: 'Observación', width: 300 }
    ]
    if (!isOpen) return null;
    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-body">
                        <h3>Historial de acuerdos mutuos</h3>
                        {details ? (
                            <GdTable
                                columns={columns2}
                                data={details}
                                defaultItemsPerPage={100}
                                itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                initialSort={[0, "asc"]}
                            />
                        ) : (
                            <p>Cargando...</p>
                        )}
                        <h3>Observaciones</h3>
                        {details ? (
                            <GdTable
                                columns={columns3}
                                data={observaciones}
                                defaultItemsPerPage={100}
                                itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                initialSort={[0, "asc"]}
                            />
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};
const ObservationModal = ({ isOpen, onClose, auxiliarID }) => {
    const [observation, setObservation] = useState("");

    if (!isOpen) return null;

    const handleSaveObservation = async () => {
        console.log("Enviando observación para auxiliarID:", auxiliarID);
        console.log("Observación:", observation);
        if (!auxiliarID || observation == "") {
            gdAlertify.notiError("Debe ingresar una observación");
            return;
        }

        try {
            const response = await axiosInstance.post("/auxiliar/observaciones/guardar", {
                auxiliarID,
                observacion: observation,
            });

            if (response.data.error) {
                gdAlertify.notiError(response.data.message);
                return;
            }

            gdAlertify.notiSuccess(response.data.message);
            setObservation("");
            onClose();
        } catch (error) {
            console.error("Error al guardar la observación:", error);
            gdAlertify.notiError("Hubo un error al guardar la observación.");
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="observationModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="observationModalLabel">Agregar Observación</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <label htmlFor="observationInput" className="form-label">Observación</label>
                        <textarea
                            id="observationInput"
                            className="form-control"
                            rows="4"
                            value={observation}
                            onChange={(e) => setObservation(e.target.value)} // Actualiza el estado
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={handleSaveObservation}>Guardar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const NominaAuxiliares = () => {
    const navigate = useNavigate();
    const [resultados, setResultados] = useState([]); // Estado para almacenar los auxiliares obtenidos.
    const [selectedAuxiliar, setSelectedAuxiliar] = useState(null);
    const [history, setHistory] = useState({}); // Estado para almacenar los historiales de los auxiliares.

    const [isObservationModalOpen, setIsObservationModalOpen] = useState(false);
    const [selectedAuxiliarForObservation, setSelectedAuxiliarForObservation] = useState(null);

    useEffect(() => {
        gdAlertify.showLoader()
        async function buscarAuxiliares() {
            try {
                const params = { detalle_extendido: 0, cordinacion: true };
                const response = await axiosInstance.get("/auxiliar/busqueda", { params });
                setResultados(response.data.data); // Almacena los resultados en el estado.
                gdAlertify.hideLoader()
            } catch (error) {
                gdAlertify.hideLoader()
                console.error("Error al buscar auxiliares: ", error);
            }
        };
        buscarAuxiliares();
    }, []);

    const handleViewHistory = async (auxiliarID) => {
        try {
            const response = await axiosInstance.get(`/auxiliar/${auxiliarID}/historial`);
            setHistory((prev) => ({ ...prev, [auxiliarID]: response.data.data }));
            setSelectedAuxiliar(auxiliarID);
        } catch (error) {
            console.error("Error al obtener el historial del auxiliar: ", error);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detalleAuxiliar, setDetalleAuxiliar] = useState(null);
    const [obsercaionesAuxiliar, setObservacionesAuxiliar] = useState(null);

    const verHistorial = useCallback(async (idAuxiliar) => {
        setIsModalOpen(true);
        setDetalleAuxiliar(null);
        const params = { idAuxiliar };
        try {
            const response = await axiosInstance.get("/auxiliar/historial", { params });
            setDetalleAuxiliar(response.data.data.historial);
            setObservacionesAuxiliar(response.data.data.observaciones);
        } catch (error) {
            console.error(error);
            setDetalleAuxiliar({ error: "No se pudo cargar la información" });
        }
    }, []);

    const handleAddObservation = useCallback((auxiliarID) => {
        setSelectedAuxiliarForObservation(auxiliarID);
        setIsObservationModalOpen(true);
    }, []);

    const columns = [
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <div className="dropdown">
                        <button
                            className="btn btn-sm btn-primary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Acciones
                        </button>

                        <ul className="dropdown-menu">

                            {/* Editar */}
                            <li>
                                <button
                                    className="dropdown-item text-primary"
                                    onClick={() => navigate('/ingreso-auxiliar/' + row.id)}
                                >
                                    <i className="bi bi-pencil-square me-2"></i>
                                    Editar
                                </button>
                            </li>

                            {/* Ver Historial */}
                            <li>
                                <button
                                    className="dropdown-item text-success"
                                    onClick={() => verHistorial(row.id)}
                                >
                                    <i className="bi bi-clock-history me-2"></i>
                                    Ver Historial
                                </button>
                            </li>

                            {/* Agregar Observación */}
                            <li>
                                <button
                                    className="dropdown-item text-secondary"
                                    onClick={() => handleAddObservation(row.id)}
                                >
                                    <i className="bi bi-chat-left-text me-2"></i>
                                    Agregar Observación
                                </button>
                            </li>

                        </ul>
                    </div>
                );
            },
            width: 100
        },
        { name: "nombreAuxiliar", title: "Nombre de Auxiliar", width: 300 },
        { name: 'celular', title: 'Celular', width: 100 },
        { name: 'fechaIngreso', title: 'Fecha de Ingreso', render: (row) => formatDate(row.fechaIngreso), width: 100 },
        { name: 'fechaNacimiento', title: 'Edad', render: (row) => calculateAge(row.fechaNacimiento), width: 100 },
        { name: 'direccion', title: 'Dirección', render: (row) => (row.direccion), width: 200 },
        { name: 'des_comuna', title: 'Comuna', render: (row) => (row.des_comuna), width: 200 },
        { name: 'clasificacionID', title: 'Clasificación', render: (row) => clasificacionMap[row.clasificacionID], getFilterValue: (row) => clasificacionMap[row.clasificacionID], width: 200 },
        { name: 'des_categoria', title: 'Categorización', width: 100 },
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <button className="btn btn-primary" onClick={() => navigate('/ingreso-auxiliar/' + row.id)}>
                        Editar
                    </button>
                )
            },
            width: 100
        },
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <button className="btn btn-success" onClick={() => verHistorial(row.id)}>
                        Ver Historial
                    </button>
                )
            },
            width: 100
        },
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <button className="btn btn-secondary" onClick={() => handleAddObservation(row.id)}>
                        Agregar Observación
                    </button>
                )
            },
            width: 100
        },
    ]
    return (
        <div className="container-fluid mt-5">
            <div className="card p-4">
                <h3 className="mb-4">Nomina de Auxiliares</h3>

                {/* Tabla principal */}
                <GdTable
                    columns={columns}
                    data={resultados}
                    defaultItemsPerPage={100}
                    itemsPerPageOptions={[5, 10, 25, 50, 100]}
                    initialSort={[0, "asc"]}
                />
            </div>
            {/* Modales */}
            <DetalleAuxiliar
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                details={detalleAuxiliar}
                observaciones={obsercaionesAuxiliar}
            />
            <ObservationModal
                isOpen={isObservationModalOpen}
                onClose={() => setIsObservationModalOpen(false)}
                auxiliarID={selectedAuxiliarForObservation}
            />
        </div>
    );
};

export default NominaAuxiliares;
